import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from 'react';
import { select_elements_options } from 'z3k-settings/components/utils/z3k-selectors';
import { DeviceCustomContentSelections } from './tree-item';
import { useDashboardSettings } from '../../provider/types';
import { getDefaultDashboardDevice } from '../devices';
export const DashboardDeviceSettingsTree = memo(function DashboardDeviceSettingsTree(props) {
    const { device_id, z3k_config, device_spec, device_type } = props;
    const data = useMemo(() => select_elements_options(z3k_config, device_spec).map((item, index) => ({
        id: index,
        ...item,
    })), [z3k_config, device_spec]);
    const { dashboard_config, setDashboardConfig } = useDashboardSettings();
    const onChange = useCallback((items) => {
        setDashboardConfig((config) => {
            const device_in_config = config.devices?.find((device) => device.id === device_id);
            const config_devices = device_in_config
                ? config.devices
                : [
                    ...(config.devices ?? []),
                    getDefaultDashboardDevice(device_id, device_type),
                ];
            const devices = config_devices?.map((device) => {
                if (device.id === device_id) {
                    return { ...device, items };
                }
                return device;
            });
            return { ...config, devices };
        });
    }, [device_id, device_type]);
    const items = useMemo(() => dashboard_config.devices?.find(({ id }) => id === device_id)?.items, [dashboard_config.devices, device_id]);
    return (_jsx(DeviceCustomContentSelections, { data: data, items: items, onChange: onChange }));
});
